import { z } from "zod"
import { OrganizationTypeEnum } from "../../companies/dtos"

export const BackofficeOrganizationCompanyResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  name: z.string(),
  logo: z.string().nullable(),
})

const BackofficeOrganizationBaseResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  name: z.string(),
  slug: z.string(),
  logo: z.string().nullable(),
  type: z.enum(OrganizationTypeEnum),
  createdAt: z.date().transform((value) => value.toISOString()),
  owner: z
    .object({
      id: z.bigint().transform(String),
      name: z.string(),
    })
    .nullable(),
  lastEmployee: z
    .object({
      id: z.bigint().transform(String),
      name: z.string(),
      email: z.string(),
      lastSeenAt: z
        .date()
        .transform((value) => value.toISOString())
        .nullable()
        .optional(),
    })
    .nullable()
    .optional(),
  creditPackages: z.array(z.object({ credits: z.number() })).optional(),
  subscriptions: z.array(z.object({ credits: z.number() })).optional(),
  packageCredits: z.number(),
  subscriptionCredits: z.number(),
  companies: z.array(BackofficeOrganizationCompanyResponseDataSchema),
})

export const BackofficeOrganizationResponseDataSchema = BackofficeOrganizationBaseResponseDataSchema

export const BackofficeOrganizationsResponseDataSchema = z.array(
  BackofficeOrganizationResponseDataSchema,
)

export const BackofficeImpersonateOrganizationResponseDataSchema = z.object({
  token: z.string(),
})
